// Texty přihlášení/registrace/obnovy hesla — slovenské dvojče locale/cs/authPage.js.
import { NBSP } from '../../modules/money.js';

export default {
  head: {
    login: { title: 'Vitajte späť', sub: 'Prihláste sa do svojho účtu Jipos' },
    register: { title: 'Založiť účet', sub: 'Registrácia zaberie necelú minútu' },
  },
  tabs: {
    login: 'Prihlásenie',
    register: 'Registrácia',
  },
  switchText: {
    login: { text: 'Nemáte účet?', link: 'Zaregistrujte sa' },
    register: { text: 'Už máte účet?', link: 'Prihláste sa' },
  },
  labelEmail: 'E-mail',
  labelPassword: 'Heslo',
  labelForgot: 'Zabudnuté heslo?',
  labelBack: 'Späť na prihlásenie',
  typeDesc: {
    retail: 'Bežný nákup pre seba',
    wholesale: 'Firma s IČO, vlastný cenník',
  },
  b2bNote: 'Veľkoobchodný cenník schvaľujeme ručne. Po registrácii sa vám ozveme do jedného pracovného dňa.',
  panel: {
    eyebrow: 'Účet Jipos',
    title: 'Nakupujte rýchlejšie a majte všetko pod kontrolou',
  },
  benefits: [
    { icon: 'package', title: 'Prehľad objednávok', text: 'História nákupov a stav zásielok na jednom mieste' },
    { icon: 'bolt', title: 'Rýchlejší nákup', text: 'Uložené doručovacie a fakturačné údaje' },
    { icon: 'heart', title: 'Obľúbené produkty', text: 'Uložte si náradie, ku ktorému sa chcete vrátiť' },
    { icon: 'percent', title: 'Vernostné zľavy', text: 'Exkluzívne akcie a zľavy len pre prihlásených' },
    { icon: 'store', title: 'B2B ceny', text: 'Firmy s IČO získajú veľkoobchodný cenník až −20' + NBSP + '%' },
  ],
  trust: {
    before: 'Vyše ',
    between: ' a ',
    after: ' overených hodnotení. Nakupujte bezpečne.',
  },
};
